// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"844":"antiAgingPaket","962":"home"}[chunkId] || chunkId) + "." + {"844":"ceed674b","858":"9b039f8a","962":"dc4cce68"}[chunkId] + ".js";
};